import React from "react";
import { Link } from "react-router-dom";
import Services from "../../api/service";

interface ServiceSectionProps {
  sClass?: string;
}

interface ServiceItem {
  simg: string;
  slug: string;
  title: string;
}

const ServiceSection: React.FC<ServiceSectionProps> = ({ sClass = "" }) => {
  const ClickHandler = (): void => {
    window.scrollTo({ top: 10, behavior: "smooth" });
  };

  return (
    <section
      className={`wpo-service-section section-padding ${sClass}`}
      id="Service"
    >
      <div className="container-fluid">
        <div className="wpo-section-title">
          <h2 className="poort-text poort-in-right">
            Our Awesome Services For You
          </h2>
          <p>
            From intimate gatherings to grand luxury weddings, we bring together
            creativity, organization, and passion to design every detail with
            precision.
          </p>
        </div>

        <div className="wpo-service-wrap">
          <div className="row">
            {Services.slice(0, 4).map((service: ServiceItem, index: number) => (
              <div
                className="col-xl-3 col-lg-6 col-md-6 col-12"
                key={index}
              >
                <div
                  className="wpo-service-item wow fadeInUp"
                  data-wow-duration="1000ms"
                >
                  <div className="wpo-service-img">
                    <div className="wpo-service-img-inner">
                      <img
                        src={service.simg}
                        alt={service.title || "Service Image"}
                      />
                    </div>
                  </div>
                  <div className="wpo-service-text">
                    <h3>
                      <Link
                        onClick={ClickHandler}
                        to={`/service-single/${service.slug}`}
                      >
                        {service.title}
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
